export const PACKAGING = [
    {
      item: 'Customized Projects',
      itemDescription: 'Our team has been producing customized projects for customers in various industries ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/customizedProjects.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/customizedProjects.webp',
      path: '/packaging/customized-projects',
    },
    {
      item: 'Eco-Friendly Packaging',
      itemDescription: 'Committed to minimizing environmental impact, we employ innovative materials and designs that prioritize both functionality and sustainability...',
      itemImageDesktop: '/images/packaging/packaging/desktop/ecoFriendlyPackaging.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/ecoFriendlyPackaging.webp',
      path: '/packaging/eco-friendly-packaging',
    },
    {
      item: 'E-Commerce Assistant',
      itemDescription: 'We specialize in crafting packaging solutions that not only ensure the safe transit of items but also elevate the unboxing experience ... ',
      itemImageDesktop: '/images/packaging/packaging/desktop/e-commerceAssistant.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/e-commerceAssistant.webp',
      path: '/packaging/e-commerce-assistant',
    },
    {
      item: 'Jewelry Boxes',
      itemDescription: 'Jewelry boxes are exquisite containers designed to protect and display ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/jewelryBoxes.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/jewelryBoxes.webp',
      path: '/packaging/jewelry-boxes',
    },
    {
      item: 'Jewelry Case',
      itemDescription: 'Jewelry boxes are exquisite containers designed to protect and display ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/jewelryCase.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/jewelryCase.webp',
      path: '/packaging/jewelry-cases',
    },
    {
      item: 'Jewelry Display',
      itemDescription: 'Jewelry display sets come in a variety of styles, materials, and configurations ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/jewelryDisplay.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/jewelryDisplay.webp',
      path: '/packaging/jewelry-displays',
    },
    {
      item: 'Jewelry Pouches',
      itemDescription: "To ensure that your jewelry pouches become an extension of your brand's identity, we offer customization options ...",
      itemImageDesktop: '/images/packaging/packaging/desktop/jewelryPouches.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/jewelryPouches.webp',
      path: '/packaging/jewelry-pouches',
    },
    {
      item: 'Premium Paper Bags',
      itemDescription: 'Our selection of high-quality bags is perfect for businesses looking to elevate their brand image ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/premiumPaperBags.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/premiumPaperBags.webp',
      path: '/packaging/premium-paper-bags',
    },
    {
      item: 'Shopping Aids',
      itemDescription: 'Our expertise lies in producing captivating shopping aids tailored specifically for jewelers ...',
      itemImageDesktop: '/images/packaging/packaging/desktop/shoppingAids.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/shoppingAids.webp',
      path: '/packaging/shopping-aids',
    },
    {
      item: 'Watch Packaging',
      itemDescription: 'Watches are not just functional accessories; they are expressions of personal style and achievements ... ',
      itemImageDesktop: '/images/packaging/packaging/desktop/watchPackaging.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/watchPackaging.webp',
      path: '/packaging/watch-packaging',
    },
    {
      item: 'Watch Display',
      itemDescription: 'Our watch display is made with high-quality materials and construction...',
      itemImageDesktop: '/images/packaging/packaging/desktop/watchDisplay.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/watchDisplay.webp',
      path: '/packaging/watch-displays',
    },
    {
      item: 'Smart Packaging',
      itemDescription: 'We recognize the importance of smart packaging and are capable of producing it as a large manufacturer...',
      itemImageDesktop: '/images/packaging/packaging/desktop/smartPackaging.webp',
      //itemImageMobile: '/images/packaging/packaging/mobile/smartPackaging.webp',
      path: '/packaging/smart-packaging',
    },
]